import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface CornerLabelFieldProps {
  label: string;
  children: ReactNode;
  className?: string;
  labelClassName?: string;
  labelBgClassName?: string;
}

export function CornerLabelField({
  label,
  children,
  className,
  labelClassName,
  labelBgClassName = "bg-transparent",
}: CornerLabelFieldProps) {
  return (
    <div className={cn("corner-label-field", className)}>
      <span
        className={cn(
          "corner-label-field__label text-[#000000] pointer-events-none",
          labelBgClassName,
          labelClassName
        )}
      >
        {label}
      </span>
      {children}
    </div>
  );
}
